module.exports = __webpack_public_path__ + "static/media/logo.0fc8e73f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 196
// module chunks = 0